import Home from "../pages/home";
export var Routes = {
    "/:filePath+": Home,
};
